/* eslint-disable no-console */
import {FC, useMemo} from "react";
import {CreatePlanSummary} from "../../view-model";
import {usePlan} from "../../context";
import {summarizePlan} from "../../helpers";
import {CreatePlanTreeView, SummaryCard} from "../common";
import {ReviewPlanStepNodeLabel} from "./ReviewPlanStepNodeLabel";
import "../common/BuilderStep.scss";

export const ReviewPlanStep: FC = () => {
  const {plan} = usePlan();
  const summary = useMemo<CreatePlanSummary>(() => summarizePlan(plan), [plan]);

  return (
    <section
      data-testid={"review-plan-step"}
      className={"hierarchy-builder-step review-plan-step"}>
      <section data-testid={"summary-section"} className={"summary-section"}>
        <SummaryCard
          baseKey={"create-operational-hierarchy.plan-summary.creating"}
          count={summary.creating.length}
        />
        <SummaryCard
          baseKey={"create-operational-hierarchy.plan-summary.existing"}
          count={summary.existing.length}
        />
      </section>
      <section
        data-testid={"hierarchy-section"}
        className={"hierarchy-section"}>
        <CreatePlanTreeView
          interactive={false}
          label={ReviewPlanStepNodeLabel}
        />
      </section>
    </section>
  );
};
